import React from 'react';
import { Typography, Tabs } from 'antd';
import SuperAdminDetailForm from '../../components/user/userDetailForm';
import SuperAdminBrandList from './superAdminBrands';
import SuperAdminMarketingAgencies from './superAdminMarketingAgencies';

const { Text } = Typography;

const SuperAdminUserScreen = () => {
  return (
    <div>
      <div className="user-header">
        <div>
          <Text className="main-heading">User</Text>
        </div>
      </div>
      <div className="user-tab-container">
        <Tabs defaultActiveKey="1" animated={{ inkBar: true, tabPane: true }}>
          <Tabs.TabPane tab="User Details" key="1">
            <SuperAdminDetailForm isSuperAdmin />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Brands" key="2">
            <SuperAdminBrandList />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Marketing Agency" key="3">
            <SuperAdminMarketingAgencies />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default SuperAdminUserScreen;
